import { render, staticRenderFns } from "./Page15.vue?vue&type=template&id=16f8f76b&scoped=true&"
import script from "./Page15.vue?vue&type=script&lang=ts&"
export * from "./Page15.vue?vue&type=script&lang=ts&"
import style0 from "./Page15.vue?vue&type=style&index=0&id=16f8f76b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f8f76b",
  null
  
)

export default component.exports